var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('el-popover',{attrs:{"placement":"right","trigger":"hover","popper-class":"uxun-poppper"}},[_c('img',{staticClass:"small-img",attrs:{"slot":"reference","src":_vm.src,"alt":""},slot:"reference"}),_c('img',{staticClass:"medium-img",attrs:{"src":_vm.src,"alt":""}})]):_c('img',{staticClass:"empty",attrs:{"src":_vm.empty,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }